import axios from '../../axios'
import { addZhiniaoPrefix } from '@utils/SSOHelper'

export const URL = {
  // 获取消息列表
  getMessageList: 'learn/app/clientapi/message/getMessageList.do',

  // 获取身份列表
  queryUserInfoBound: 'learn-login/queryUserInfoBound.do',

  // 切换身份
  enterpriseIsActive: 'learn-login/enterpriseIsActive.do',
  // 获取首页
  queryHome: 'learn/app/clientapi/home/queryHome.do',

  getLiveroomAnswerInfo: 'learn/app/clientapi/live/getLiveroomAnswerInfo.do',
}

export default {
  getMessageList(curPage: number): Promise<any> {
    return axios.post(URL.getMessageList, {
      curPage,
      numPerPage: 30,
    })
  },
  queryUserInfoBound(appId: string): Promise<any> {
    return axios.post(URL.queryUserInfoBound, { appId: appId || 'com.mlearning.guangqichuanqi' })
  },
  enterpriseIsActive(
    appId: string,
    empId: string,
    enterpriseId: string
  ): Promise<any> {
    return axios.post(URL.enterpriseIsActive, {
      appId,
      empId,
      enterpriseId,
      strOs: 66,
    })
  },
  queryHome(enterpriseId: string): Promise<any> {
    return axios.get(URL.queryHome, {
      params: {
        enterpriseId,
      },
    })
  },
  getLiveroomAnswerInfo(roomId: string): Promise<any> {
    return axios.get(addZhiniaoPrefix(URL.getLiveroomAnswerInfo), {
      params: { roomId },
    })
  },
}
